/**
 * wipeSession.js — Phase 12.32 · util compartilhado de "sessão zero".
 *
 * Usado por SetupSenha (magic link) e Login para garantir que NENHUM
 * resquício de tenant anterior sobreviva ao próximo sign-in:
 *   1. supabase.auth.signOut() — encerra o JWT vivo (impede que o
 *      onAuthStateChange do sessionBridge sobrescreva o app_session do
 *      novo usuário com o do anterior).
 *   2. Apaga TODAS as chaves de LS que carregam contexto de tenant:
 *      exatas (app_session, imp_session, v360.empresaId,
 *      s360_consult_ativa_id_v2, s360_mgc_projeto_ativo, mockUserName,
 *      v360.idioma) e por prefixo (sprints360__, s360_state_v1__,
 *      s360.ldv.cache).
 *   3. Limpa `?empresa=` / `?workspace=` da URL para não reintroduzir
 *      contexto via query param.
 *   4. Dispara `app-session-changed` / `imp-session-changed` para os
 *      contexts reagirem imediatamente.
 *
 * É idempotente e defensivo — pode ser chamado várias vezes sem efeito
 * colateral.
 */
import { getSupabase } from "@/lib/supabase";

const EXACT_KEYS = [
  "app_session",
  "imp_session",
  "v360.empresaId",
  "s360_consult_ativa_id_v2",
  "s360_mgc_projeto_ativo",
  "mockUserName",
  "v360.idioma",
];

const PREFIX_KEYS = ["sprints360__", "s360_state_v1__", "s360.ldv.cache"];

export async function wipeAnySession() {
  try {
    const sb = await getSupabase();
    await sb.auth.signOut();
  } catch { /* signOut é idempotente */ }
  try {
    EXACT_KEYS.forEach(k => { try { localStorage.removeItem(k); } catch { /* noop */ } });
    const toRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && PREFIX_KEYS.some(p => k.startsWith(p))) toRemove.push(k);
    }
    toRemove.forEach(k => { try { localStorage.removeItem(k); } catch { /* noop */ } });
    try {
      const u = new URL(window.location.href);
      let changed = false;
      if (u.searchParams.has("empresa"))   { u.searchParams.delete("empresa");   changed = true; }
      if (u.searchParams.has("workspace")) { u.searchParams.delete("workspace"); changed = true; }
      if (changed) window.history.replaceState({}, "", u.toString());
    } catch { /* noop */ }
    window.dispatchEvent(new CustomEvent("app-session-changed"));
    window.dispatchEvent(new CustomEvent("imp-session-changed"));
  } catch { /* noop */ }
}
